<div class="footer-branding">
    @if (configuration.logo?.src) {
    <div class="footer-logo">
        @if (!!configuration.logo.href) {
        <a href="{{ configuration.logo.href }}">
            <img
                src="{{ configuration.logo.src }}"
                alt="{{ configuration.logo.alt }}"
            />
        </a>
        } @if (!configuration.logo.href) {
        <img
            src="{{ configuration.logo.src }}"
            alt="{{ configuration.logo.alt }}"
        />
        }
    </div>
    } @if (configuration.newsletterDisplay) {
    <div class="footer-newsletter">
        <div class="footer-newsletter-text">
            {{ configuration.newsletterLabel }}
        </div>
        <form
            [formGroup]="form"
            (ngSubmit)="submitNewsletter()"
            class="footer-newsletter-form"
        >
            <input
                formControlName="email"
                placeholder="{{ configuration.newsletterPlaceholder }}"
            />
            <button type="submit">
                <i class="fa fa-chevron-right"></i>
            </button>
        </form>
        @if (formError) {
        <div class="footer-newsletter-error">
            {{ formError }}
        </div>
        } @if (formSuccess) {
        <div class="footer-newsletter-success">
            {{ formSuccess }}
        </div>
        }
    </div>
    }
</div>
@if (configuration.navItems?.length > 0) {
<ul class="footer-nav">
    @for (item of configuration.navItems; track item) {
    <li>
        <ng-container
            *ngTemplateOutlet="navItem; context: { $implicit: item }"
        ></ng-container>
    </li>
    }
</ul>
} @if (configuration.addressItems?.length > 0 || configuration.phone?.href) {
<div class="footer-location">
    @if (configuration.addressItems) {
    <ul class="footer-address">
        @for (item of configuration.addressItems; track item) {
        <li>
            {{ item }}
        </li>
        }
    </ul>
    } @if (configuration.phone?.href && configuration.phone?.content) {
    <div class="footer-phone">
        <a href="tel:{{ configuration.phone.href }}">{{
            configuration.phone.content
        }}</a>
    </div>
    } @if (!!configuration.socialMediaItems &&
    configuration.socialMediaItems.length > 0) {
    <ul class="footer-social-media">
        @for (item of configuration.socialMediaItems; track item) {
        <li>
            <a href="{{ item.href }}">
                <i class="fa {{ item.icon }}"></i>
            </a>
        </li>
        }
    </ul>
    }
</div>
} @if (configuration.subNavItems?.length > 0) {
<ul class="footer-sub-nav">
    @for (item of configuration.subNavItems; track item) {
    <li>
        <ng-container
            *ngTemplateOutlet="navItem; context: { $implicit: item }"
        ></ng-container>
    </li>
    }
</ul>
} @if (configuration.copyright) {
<div class="footer-copyright" [innerHtml]="getCopyright()"></div>
} @if (!!configuration.poweredByLogo) {
<div class="footer-powered-by">
    @if (configuration.poweredByLink) {
    <a href="{{ configuration.poweredByLink }}"
        >Powered By
        <img src="{{ configuration.poweredByLogo }}" />
    </a>
    } @if (!configuration.poweredByLink) {
    <img src="{{ configuration.poweredByLogo }}" />
    }
</div>
}

<ng-template #navItem let-item>
    @switch (item.type) { @case ('a') {
    <a class="footer-nav-item" href="{{ item.href }}">
        {{ item.content }}
    </a>
    } @case ('a-ng') {
    <a class="footer-nav-item" [routerLink]="item.routerLink">
        {{ item.content }}
    </a>
    } @default {
    <span class="footer-nav-item">
        {{ item.content }}
    </span>
    } }
</ng-template>
